import apiClient from './apiClient';

export interface CurrencyRates {
  base: string;
  rates: Record<string, number>;
}

export interface GeoLocation {
  countryCode: string | null;
  currency: string | null;
}

export const currencyApi = {
  /** USD-based exchange rates for every supported currency. */
  getRates: async (): Promise<CurrencyRates> => {
    const raw = await apiClient.get<{ success: boolean; data: CurrencyRates }>('/currency/rates', { requireAuth: false });
    return raw.data;
  },

  /** Guess the visitor's currency from their IP address. */
  locate: async (): Promise<GeoLocation> => {
    const raw = await apiClient.get<{ success: boolean; data: GeoLocation }>('/currency/locate', { requireAuth: false });
    return raw.data;
  },
};

export default currencyApi;
